import { TSortDirection, TColumnSorting, IColumn } from "./interfaces";

export function encodeSorting(sorting: TColumnSorting): TSortDirection {
  if (sorting.active) return sorting.direction;
  return false;
}

export function decodeSorting(sortDirection: TSortDirection): TColumnSorting {
  if (sortDirection === "desc") {
    return {
      active: true,
      direction: "desc"
    };
  }

  if (sortDirection === "asc") {
    return {
      active: true,
      direction: "asc"
    };
  }

  return {
    active: false,
    direction: "desc"
  };
}

export function nextSort(sortDirection: TSortDirection) {
  const order = [false, "asc", "desc"];
  const idx = order.findIndex(o => o === sortDirection);
  const nextSortIdx = (idx + 1) % 3;
  return order[nextSortIdx];
}

export function parseCell(cell: any, column: IColumn): string {
  if (column.parse) {
    return column.parse(cell);
  }

  switch (column.type) {
    case "date":
      return (cell as Date).toLocaleDateString();
    case "empty":
      return "";
    case "number":
      return String(cell);
    case "text":
    default:
      return cell;
  }
}

export function sortFactory(sortDirection: "asc" | "desc") {
  const ascSort = (a: any, b: any) => {
    if([null, undefined].includes(a)) return 1
    if([null, undefined].includes(b)) return -1
    return (a > b ? 1 : a < b ? -1 : 0);
  }
  const decSort = (a: any, b: any) => {
    if([null, undefined].includes(a)) return 1
    if([null, undefined].includes(b)) return -1
    return (b > a ? 1 : b < a ? -1 : 0);
  }
  if (sortDirection === "asc") return ascSort;
  return decSort;
}
